import IMask from 'imask';

export const isVisible = elem => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

export default function () {


    $(document).ready(function () {

        if ($("#login-form").length === 1) {
            $("input[type='text']:visible:enabled:first").focus();
        }


        $(".tagline strong").on("click", function () {
            var target = $(this).closest(".tagline").data("target");
            var txtToAdd = $(this).text();
            var tagMode = false;
            if ($(this).closest(".tagline").data("target-tag"))
                tagMode = $(this).closest(".tagline").data("target-tag") == "1";

            if (tagMode) {
                txtToAdd = "[[" + txtToAdd + "]]";
            }

            if (typeof CKEDITOR !== 'undefined' && CKEDITOR.instances[target]) {

                CKEDITOR.instances[target].insertText(txtToAdd);
                return;
            }

            var $txt = $("#" + target);

            if (tagMode) {
                var caretPos = $txt[0].selectionStart || 0;
                var textAreaTxt = $txt.val();
                var finalValue = textAreaTxt.substring(0, caretPos) + txtToAdd + textAreaTxt.substring(caretPos);
                $txt.val(finalValue);
            } else {
                $txt.val(txtToAdd);
            }
        });

        document.querySelectorAll('[data-char-count]').forEach(item => {
            const maxCount = parseInt(item.dataset.charCount, 10);
            const counterId = "counter-for-" + item.id;
            const counterItem = document.createElement("div");
            counterItem.className = "box-leftchar-counter";
            counterItem.id = counterId;

            item.addEventListener("blur", () => {
                const existing = document.getElementById(counterId);
                if (existing) existing.remove();
            });

            item.addEventListener("focus", () => {
               
                item.insertAdjacentElement("afterend", counterItem);
                counterItem.textContent = `${item.value.length}/${maxCount}`;
            });

            item.addEventListener("input", () => {
                counterItem.textContent = `${item.value.length}/${maxCount}`;
            });
        });
   

   
        const numberinputs = document.querySelectorAll('.numberinput');
        const negativenumberinputs = document.querySelectorAll('.negativenumberinput');

        negativenumberinputs.forEach(input => {
            IMask(input, {
                mask: Number,
                padFractionalZeros: false,
                normalizeZeros: false,
                radix: ',',
                scale: 3,
                min: -9999999999,
                max: 9999999999,
                autofix: false
            });
        });

        numberinputs.forEach(input => {
            IMask(input, {
                mask: Number,
                padFractionalZeros: false,
                normalizeZeros: false,
                radix: ',',
                min: 0,
                scale: 3,
                max: 9999999999,
                autofix: false
            });
        });
    });
}